import React from "react";
import Loader from '../Loader'

export default class Paypal extends React.Component {

    state = {
        loading: false
    }

    componentDidMount() {
        const script = document.createElement('script')
        script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.PAYPAL_KEY}&currency=EUR&disable-funding=card`
        script.async = false
        script.onload = () => {
            this.setState({ loading: false }, () => {
                paypal.Buttons({
                    createOrder: (data, actions) => {
                        return actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        value: this.props.booking.bookingTotal,
                                        currency: 'EUR',
                                        breakdown: {
                                            item_total: {
                                                currency_code: "EUR",
                                                value: this.props.booking.bookingTotal
                                            },
                                        },
                                    },
                                    items: [
                                        {
                                            name: `${this.props.event.eventName} - ${this.props.booking.bookingResponsibleUser.firstname} ${this.props.booking.bookingResponsibleUser.lastname}, BookingId: ${this.props.booking.id}`,
                                            description: `${this.props.event.eventName} - ${this.props.booking.bookingResponsibleUser.firstname} ${this.props.booking.bookingResponsibleUser.lastname}, BookingId: ${this.props.booking.id}`,
                                            unit_amount: {
                                                currency_code: 'EUR',
                                                value: this.props.booking.bookingTotal
                                            },
                                            quantity: 1
                                        }
                                    ]
                                }
                            ]
                        })
                    },
                    onApprove: (data, actions) => {
                        return actions.order.capture()
                            .then((details) => {
                                this.props.transaction.paypalTransactionOrderId = data.orderID
                                this.props.transaction.transactionStatus = "Success"
                                this.props.submit()
                            })
                    },
                    onCancel: (data) => {
                        this.props.transaction.paypalTransactionOrderId = data.orderID
                        this.props.transaction.transactionStatus = "Cancelled"
                        this.props.submit()
                    },
                    onError: (err) => {
                        this.props.transaction.paypalTransactionOrderId = err.orderId
                        this.props.transaction.transactionStatus = "Error"
                        this.props.transaction.transactionErrorText = JSON.stringify(err)
                        this.props.submit()
                    }
                }).render("#PaypalButtons")
            })
        }

        this.setState({ loading: true })

        document.body.appendChild(script)
    }

    render() {
        return (
            <>
            <div id="PaypalButtons" style={{ marginTop: '10em' }}>
                {
                    // this.state.show &&
                    // <paypal.Button.react />
                }
            </div>
            {
                this.state.loading && <Loader />
            }
            </>
        )
    }
}